<template>
    <div class="project">
        <div class="project-select">
            <el-popover
                placement="bottom"
                transition="el-zoom-in-top"
                v-model="visible"
                popper-class="project-select-popper"
                :disabled="projList && projList.length > 1 ? false: true"
                trigger="click">
                <div class="project-select-popper-change" slot="reference">
                    <span class="project-select-popper-change-name">{{currentProj.label}}</span>
                    <img v-if="projList && projList.length > 1" class="project-select-popper-img" :src="changeImg" alt="">
                    <span v-if="projList && projList.length > 1" style="margin-left: 4px;font-size: 16px;">切换项目</span>
                </div>
                <el-scrollbar class="project-select-popper-proj">
                    <ul class="project-select-popper-proj-list">
                        <li class="project-select-popper-proj-list-item"
                            v-for="item in projList"
                            @click.stop="onSelectedProj(item)"
                            :class="{active: currentProj.id === item.id}"
                            :key="item.id"
                        >{{item.label}}</li>
                    </ul>
                </el-scrollbar>
            </el-popover>
        </div>
    </div>
</template>

<script>
import changeImg from '@/assets/images/icon/change.png'
export default {
    name: 'stats-header',
    props: {
        api: {
           type: String,
            default: 'statistics/stats/projList' 
        }
    },
    data () {
        return {
            changeImg,
            visible: false,
            projList: [],
            currentProj: {}
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler (val, old) {
                if (val && old && val.id !== old.id) {
                    this.currentProj = val
                }
            }
        }
    },
    methods: {
        getProjList () {
            this.$api(this.api).then(res => {
                this.projList = res
                this.currentProj = this.projList[0]
                this.$emit('change', this.currentProj)
            }).catch(err => {
                this.$tips(err, 'error')
            })
        },
        onSelectedProj (proj) {
            if (proj.id !== this.currentProj.id) {
                this.currentProj = proj
                this.$emit('change', this.currentProj)
            }
            this.visible = false
        }
    },
    mounted () {
        this.getProjList()
    }
}
</script>

<style lang="less">
@title: rgba(0,0,0,.85);
.project {
    &-select {
        &-popper {
            padding: 10px 0!important;
            overflow-x: hidden;
            &.el-scrollbar__wrap {
                overflow-x: hidden!important;
            }
            &-img{
                cursor: pointer;
                width: 24px;
                height: 24px;
                vertical-align: middle;
            }
            &-change {
                display: inline-flex;
                align-items: center;
                cursor: pointer;
                line-height: 24px;
                color: #409bff;
                &-name {
                    // color: @title;
                    font-weight: 500;
                    font-size: 18px;
                }
            }
            &-proj {
                height: 180px;
                .el-scrollbar__wrap {
                    overflow-x: hidden!important;
                }
                &-list {
                    overflow-x: hidden;
                    &-item {
                        line-height: 36px;
                        text-align: center;
                        padding: 0 20px;
                        font-size: 14px;
                        color: #606060;
                        background: #fff;
                        cursor: pointer;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        &.active {
                            color: #409bff;
                            background: #ECF5FF;
                        }
                    }
                }
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/statistics/header.vue